// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1V8W_","text":"SelectPayment_text__1jXCE","title":"SelectPayment_title__1vjtn","btn":"SelectPayment_btn__1LWB8"};